import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { Event } from '../event';

export default function EventCard({ event, onDelete }: { event: Event, onDelete: () => void }) {

    async function deleteEvent(id: string) {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/event/${id}`, {
            method: 'DELETE'
        });

        if (!res.ok) {
            const data = await res.json();
            console.error(data.message);
        }

        onDelete();
    }

    return (
        <div key={event.id} className={event.hidden ? 'event hidden' : 'event'}>
            <div className={'title'}>{event.title}</div>
            <div className={'description'}>{event.description}</div>
            <div className={'location'}>{event.location}</div>
            <div className={'startDate'}>{event.startDate.toLocaleString()}</div>
            <div className={'endDate'}>{event.endDate.toLocaleString()}</div>
            <div className={'imageUrl'}>
                <img width={300} src={event.imageUrl} alt={event.title} />
            </div>
            <Link to={{ pathname: "/events/" + event.id }}><Button variant="primary">Edit</Button></Link>
            <Button variant="danger" onClick={() => deleteEvent(event.id)}>Delete</Button>
        </div>
    );
}
